module.exports = __webpack_public_path__ + "static/cutcolorclip-971fac247ea0e8ee6d8ae46d7a8786b6.gif";